var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9916 11.5C34.9639 11.2199 34.8656 10.9514 34.7059 10.7197C34.5461 10.488 34.3302 10.3006 34.0783 10.175L20.7449 3.50835C20.5134 3.39248 20.258 3.33215 19.9991 3.33215C19.7402 3.33215 19.4848 3.39248 19.2533 3.50835L5.91995 10.175C5.66873 10.3013 5.45347 10.4889 5.2941 10.7205C5.13473 10.9522 5.03642 11.2203 5.00828 11.5C4.98995 11.6783 3.40661 29.445 19.3233 36.5233C19.536 36.6193 19.7666 36.669 19.9999 36.669C20.2333 36.669 20.4639 36.6193 20.6766 36.5233C36.5933 29.445 35.0099 11.68 34.9916 11.5ZM19.9999 33.1617C8.71828 27.7083 8.18494 16.07 8.27661 12.725L19.9999 6.86335L31.7149 12.7217C31.7766 16.0367 31.1683 27.7517 19.9999 33.1617Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 20.9767L14.5117 17.155L12.155 19.5117L18.3334 25.69L27.845 16.1783L25.4884 13.8217L18.3334 20.9767Z",
    fill: "#080A52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdStatus);
export default __webpack_public_path__ + "static/media/id-status.8f6cfabe1a87a638a60d4f74235e8d75.svg";
export { ForwardRef as ReactComponent };